import { getBar, getTheatrePaymentInfo } from '../../services/data';
import { barLog } from '../../services/log';
import { types } from '../../types';
import errorException from '@/helpers/errorException';

export const bar = {
  async loadBar({ commit }, payload) {
    return;
    commit(types.SET_LOADING, { loadBar: true });
    try {
      const getBarData = await getBar(payload);
      commit(types.SET_BAR, getBarData.Groups);
    } catch (e) {
      errorException(e, commit, 'loadBar');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { loadBar: false });
    }
  },

  async loadBarPage({ commit, state, dispatch }, payload) {
    return;
    try {
      const { theatreId, sessionId, filmId } = payload;

      commit(types.SET_LOADING, { loadBarPage: true });

      if (!state.bar.length) {
        await dispatch('loadBar', {
          theatreId,
          saleFilter: 'SaleEnabled',
        });
      }

      if (
        (!state.data.notifications || state.data.notifications.length === 0) &&
        filmId &&
        sessionId
      ) {
        await dispatch('getNotificationsAction', {
          theatreId,
          session: sessionId,
          filmId,
        });
      }

      if (!state.theatre.Name) {
        await dispatch('getTheatreInfo', { theatreId });
      }

      if (
        (state.setting.enabledPayments || []).length === 0 ||
        (state.setting.paymentMethods || []).length === 0
      ) {
        const theatrePaymentInfo = await getTheatrePaymentInfo({
          theatreId,
          filmId,
        });
        commit(types.SET_THEATRE_PAYMENT_INFO, theatrePaymentInfo);
      }
    } catch (e) {
      errorException(e, commit, 'loadBarPage');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { loadBarPage: false });
    }
  },

  async loadStartPageBeforeBuyBar({ dispatch, state, commit }) {
    try {
      let cities = state.data.cities;
      if (!cities) {
        cities = await dispatch('getCitiesWithTheatres', { onlyWithBar: true });
      }
    } catch (e) {
      errorException(e, commit, 'loadStartPageBeforeBuyBar');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { loadStartPageBeforeBuyBar: false });
    }
  },

  async changeFormForBar({ commit }, payload) {
    try {
      commit(types.SET_BAR_OPTION, payload);
    } catch (e) {
      errorException(e, commit, 'changeFormForBar');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { changeFormForBar: false });
    }
  },

  async postReserveBarLog({ getters, commit }, payload) {
    try {
      const { item, type } = payload;
      const userSessionId = getters.getUserSessionId;

      if (type === 'ADD_BAR_ITEM') {
        await barLog(
          {
            ChangedItem: {
              ProductId: item.Id,
              Name: item.Name,
              Count: item.count,
            },
            ChangeType: 'AddItem',
          },
          userSessionId,
        );
      }

      if (type === 'REMOVE_BAR_ITEM') {
        await barLog(
          {
            ChangedItem: {
              ProductId: item.Id,
              Name: item.Name,
              Count: item.count,
            },
            ChangeType: 'RemoveItem',
          },
          userSessionId,
        );
      }
    } catch (e) {
      errorException(e, commit, 'postReserveBarLog');
      return { success: false, error: e.message };
    } finally {
      commit(types.SET_LOADING, { postReserveBarLog: false });
    }
  },
};
